import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_TRANSACTIONS = "SET_TRANSACTIONS";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setTransactions(transactions) {
  return {
    type: SET_TRANSACTIONS,
    payload: transactions,
  };
}

export function getTransactions(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/payments`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setTransactions(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}
